import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    list: [],
};
const getters = {
    getListPipelineTicketType: state => state.list

};

const mutations = {
    PIPELINE_TICKET_TYPE_INFO(state, data) {
        state.list = data
    }
};

const actions = {
    getListPipelineTicketType({commit}) {
        axiosGet(`crm/pipeline-ticket-types/list`).then((response) => {
            commit('PIPELINE_TICKET_TYPE_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
